export default "__VITE_ASSET__DmifVVW5__"